<div class="ppl-content-container" style="padding: 8px; max-height: calc(100vh - 140px); box-sizing: border-box;">
    <div class="line2">
        {{pageTitle}}
        <div class="action">
            @if(mode==="read" && !this.isNew){
            <ppl-button [label]="'Back'" icon="fa fa-chevron-left" (click)="goBack()"
                [customClass]="'primary-button semi-rounded'" [iconPosition]="'left'"></ppl-button>
            }
        </div>
    </div>
    <div style="width: 100%">
        <ppl-accordion [title]="'Lookup Information'" [isOpen]="true">
            <div class="wiz-body">
                <div class="ppl-mt24" style="width: 100%">
                    <div class="custom-row">
                        @if(mode==="read" && !this.isNew){
                        <ppl-button label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'"
                            [iconPosition]="'left'" (click)="onEdit()" style="margin-right: 8px;"></ppl-button>
                        <ppl-button label="Delete" icon="fa fa-trash" [customClass]="'ghost-button'"
                            [iconPosition]="'left'" (click)="onDelete()"></ppl-button>
                        }
                    </div>
                    @if(mode==="edit"){
                    <form nz-form nz-row [formGroup]="lookupValueForm" class="ppl-p0">
                        @if(isAttrAvailable('lkpDomainId')){
                        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                            <nz-row>
                                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="lkpDomainId"
                                    class="ppl-form-label">{{getAttributes('lkpDomainId').label}}
                                    @if(getAttributes('lkpDomainId').mandatory === 'Y'){
                                    <span [attr.aria-label]="'Required'">*</span>
                                    }
                                </nz-form-label>
                                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                                    <div nz-tooltip [nzTooltipTitle]="getAttributes('lkpDomainId')?.tooltip || ''"
                                        nzTooltipPlacement="topRight">
                                        <div [ngClass]="{'error': validationErrors['lkpDomainId'] }">
                                            <ppl-dropdown-select formControlName="lkpDomainId" class="ppl-select" id="lkpDomainId"
                                              [options]="lookupDomainList" [optionLabel]="'lkp_domain_name'" [optionValue]="'lkp_domain_id'"
                                              placeholder="{{getAttributes('lkpDomainId').placeholder}}" />
                                          </div>
                                    </div>
                                    @if (validationErrors['lkpDomainId']) {
                                    <span class="pl-1 error-message">{{validationErrors['lkpDomainId']}}</span>
                                    }
                                </nz-form-control>
                            </nz-row>
                        </nz-form-item>
                        }
                        @if(isAttrAvailable('lkpValueCode')){
                        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                            <nz-row>
                                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="lkpValueCode"
                                    class="ppl-form-label">{{getAttributes('lkpValueCode').label}}
                                    @if(getAttributes('lkpValueCode').mandatory === 'Y'){
                                    <span [attr.aria-label]="'Required'">*</span>
                                    }
                                </nz-form-label>
                                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                                    <div nz-tooltip [nzTooltipTitle]="getAttributes('lkpValueCode')?.tooltip || ''"
                                        nzTooltipPlacement="topRight">
                                        <input nz-input formControlName="lkpValueCode" id="lkpValueCode"
                                            placeholder="{{getAttributes('lkpValueCode').placeholder}}"
                                            [ngClass]="{'error': validationErrors['lkpValueCode'] }" />
                                    </div>
                                    @if (validationErrors['lkpValueCode']) {
                                    <span class="pl-1 error-message">{{validationErrors['lkpValueCode']}}</span>
                                    }
                                </nz-form-control>
                            </nz-row>
                        </nz-form-item>
                        }
                        @if(isAttrAvailable('lkpValueName')){
                        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                            <nz-row>
                                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="lkpValueName"
                                    class="ppl-form-label">{{getAttributes('lkpValueName').label}}
                                    @if(getAttributes('lkpValueName').mandatory === 'Y'){
                                    <span [attr.aria-label]="'Required'">*</span>
                                    }
                                </nz-form-label>
                                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                                    <div nz-tooltip [nzTooltipTitle]="getAttributes('lkpValueName')?.tooltip || ''"
                                        nzTooltipPlacement="topRight">
                                        <input nz-input formControlName="lkpValueName" id="lkpValueName"
                                            placeholder="{{getAttributes('lkpValueName').placeholder}}"
                                            [ngClass]="{'error': validationErrors['lkpValueName'] }" />
                                    </div>
                                    @if (validationErrors['lkpValueName']) {
                                    <span class="pl-1 error-message">{{validationErrors['lkpValueName']}}</span>
                                    }
                                </nz-form-control>
                            </nz-row>
                        </nz-form-item>
                        }
                        @if(isAttrAvailable('lkpValueDesc')){
                        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                            <nz-row>
                                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="lkpValueDesc"
                                    class="ppl-form-label">{{getAttributes('lkpValueDesc').label}}
                                    @if(getAttributes('lkpValueDesc').mandatory === 'Y'){
                                    <span [attr.aria-label]="'Required'">*</span>
                                    }
                                </nz-form-label>
                                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                                    <div nz-tooltip [nzTooltipTitle]="getAttributes('lkpValueDesc')?.tooltip || ''"
                                        nzTooltipPlacement="topRight">
                                        <textarea rows="3" nz-input formControlName="lkpValueDesc" id="lkpValueDesc"
                                            [ngClass]="{'error': validationErrors['lkpValueDesc'] }"
                                            placeholder="{{getAttributes('lkpValueDesc').placeholder}}"></textarea>
                                    </div>
                                    @if (validationErrors['lkpValueDesc']) {
                                    <span class="pl-1 error-message">{{validationErrors['lkpValueDesc']}}</span>
                                    }
                                </nz-form-control>
                            </nz-row>
                        </nz-form-item>
                        }
                    </form>
                    @if(isNew){
                    <div class="custom-row">
                        <ppl-button [label]="'Cancel'" [icon]="'fa fa-close'"
                            style="margin-right:4px; font-size:0.857rem;" [customClass]="'ghost-button'"
                            [iconPosition]="'right'" (click)="goBack()"></ppl-button>
                        <ppl-button label="Submit" icon="fa fa-check-circle" [customClass]="'primary-button'"
                            [iconPosition]="'right'" (click)="onAdd('add')"></ppl-button>
                    </div>
                    }
                    }
                    @else if (mode==="read") {
                    <div nz-row>
                        @if(isAttrAvailable('lkpDomainId')){
                        <div nz-col nzSpan="12">
                            <div nz-row>
                                <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                                    {{ getAttributes("lkpDomainId").label }}
                                </div>
                                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.lkpDomainId }}</div>
                            </div>
                        </div>
                        }
                        @if(isAttrAvailable('lkpValueCode')){
                        <div nz-col nzSpan="12">
                            <div nz-row>
                                <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                                    {{ getAttributes("lkpValueCode").label }}
                                </div>
                                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.lkpValueCode }}</div>
                            </div>
                        </div>
                        }
                        @if(isAttrAvailable('lkpValueName')){
                        <div nz-col nzSpan="12">
                            <div nz-row>
                                <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                                    {{ getAttributes("lkpValueName").label }}
                                </div>
                                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.lkpValueName }}</div>
                            </div>
                        </div>
                        }
                        @if(isAttrAvailable('lkpValueDesc')){
                        <div nz-col nzSpan="12">
                            <div nz-row>
                                <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                                    {{ getAttributes("lkpValueDesc").label }}
                                </div>
                                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.lkpValueDesc }}</div>
                            </div>
                        </div>
                        }
                    </div>
                    }
                    <div class="custom-row">
                        @if(mode==="edit" && !this.isNew){
                        <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
                            (click)="onCancel()"></ppl-button>
                        <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'"
                            [iconPosition]="'left'" (click)="onAdd('update')"></ppl-button>
                        }
                    </div>
                </div>
            </div>
        </ppl-accordion>
    </div>
</div>
<div class="filter-panel">
    <ng-template #confirmationDialog let-cancel="cancel">
        <p> Are you sure you want to delete this lookup value ?</p>
    </ng-template>
</div>